var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    { attrs: { action: _vm.formUrl, id: "searchForm" } },
    [
      _c("fieldset", [_vm._v("Értékesítés típusa:")]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c("multiselect", {
              attrs: {
                title: _vm.t("property.forSaleForRent", "Eladó / Kiadó"),
                dataKey: "rentOrSaleTypes",
                selectData: _vm.rentOrSaleTypes,
                singleSelect: true,
                onChange: _vm.onSingleSelectChange,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c("multiselect", {
              attrs: {
                title: _vm.t("property.category", "Kategória"),
                dataKey: "propertyTypes",
                selectData: _vm.propertyTypes,
                singleSelect: true,
                defaultLabel: "Kategória",
                onChange: _vm.onSingleSelectChange,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.propertySubTypes.length
        ? _c("fieldset", [_vm._v("Altípus:")])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _vm.propertySubTypes.length
              ? _c("multiselect", {
                  attrs: {
                    title: _vm.t("property.type", "Típus"),
                    dataKey: "propertySubTypes",
                    selectData: _vm.propertySubTypes,
                    onChange: _vm.onMultiSelectChange,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-6" }, [
          _c("fieldset", [_vm._v("Elhelyezkedés:")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "label",
                {
                  staticClass: "form-field__label",
                  attrs: { for: "searchLocation" },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.t(
                          "property.typeHereTheLocation",
                          "Hol keres ingatlant?"
                        )
                      ) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("autocomplete", {
                attrs: {
                  addTerm: _vm.addLocationTerm,
                  placeholder: `${_vm.t("property.Eg", "Pl.")} Budapest`,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "search-filter__terms" },
            _vm._l(_vm.locations, function (term) {
              return _c("slug", {
                key: term.termValue,
                attrs: {
                  termValue: term.termValue,
                  title: term.title,
                  slug: term,
                },
                on: { removeSlug: _vm.removeLocationTerm },
              })
            }),
            1
          ),
        ]),
        _vm._v(" "),
        _vm.propertyType !== "telek"
          ? _c("div", { staticClass: "col-6" }, [
              _c("fieldset", [_vm._v("Építés éve:")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-field" },
                [
                  _c("label", { staticClass: "form-field__label" }, [
                    _vm._v("pl. 2008"),
                  ]),
                  _vm._v(" "),
                  _vm.propertyType !== "telek"
                    ? _c("freetext", {
                        attrs: {
                          data: this,
                          text: "adBuiltYear",
                          fieldName: "adBuiltYear",
                          placeholder: "pl. Telekom",
                        },
                        on: { onValueChange: _vm.onValueChange },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _vm.propertyType !== "telek" &&
            _vm.propertyType !== "garazs" &&
            _vm.propertyType !== "kereskedelmi-ipari-ingatlan" &&
            _vm.propertyType !== "iroda-irodahaz" &&
            _vm.propertyType !== "raktar" &&
            _vm.propertyType !== "udulo-hetvegi-haz" &&
            _vm.propertyType !== "fold-kert-tanya"
              ? _c("fieldset", [_vm._v("CSOK igénybe vehető:")])
              : _vm._e(),
            _vm._v(" "),
            _vm.propertyType !== "telek" &&
            _vm.propertyType !== "garazs" &&
            _vm.propertyType !== "kereskedelmi-ipari-ingatlan" &&
            _vm.propertyType !== "iroda-irodahaz" &&
            _vm.propertyType !== "raktar" &&
            _vm.propertyType !== "udulo-hetvegi-haz" &&
            _vm.propertyType !== "fold-kert-tanya"
              ? _c("multiselect", {
                  attrs: {
                    title: "CSOK",
                    dataKey: "adCsok",
                    selectData: _vm.adCsok,
                    singleSelect: true,
                    defaultLabel: "CSOK",
                    onChange: _vm.onSingleSelectChange,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-6" },
          [
            !_vm.propertyTypes.find(
              (p) => p.selected && p.slug === "ujepitesu-projekt"
            ) && _vm.propertyType !== "telek"
              ? _c("fieldset", [_vm._v("Állapot:")])
              : _vm._e(),
            _vm._v(" "),
            !_vm.propertyTypes.find(
              (p) => p.selected && p.slug === "ujepitesu-projekt"
            ) && _vm.propertyType !== "telek"
              ? _c("multiselect", {
                  attrs: {
                    title: _vm.t("property.condition", "Állapot"),
                    dataKey: "conditionTypes",
                    checkboxName: "all_id",
                    selectData: _vm.conditionTypes,
                    onChange: _vm.onMultiSelectChange,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _vm.propertyType !== "telek"
              ? _c("fieldset", [_vm._v("Energetikai tanúsítvány:")])
              : _vm._e(),
            _vm._v(" "),
            _vm.propertyType !== "telek"
              ? _c("multiselect", {
                  attrs: {
                    title: "Energetika",
                    dataKey: "energyCerts",
                    selectData: _vm.energyCerts,
                    singleSelect: true,
                    defaultLabel: "Energetika",
                    onChange: _vm.onSingleSelectChange,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _vm.propertyType !== "telek" &&
            _vm.propertyType !== "garazs" &&
            _vm.propertyType !== "kereskedelmi-ipari-ingatlan" &&
            _vm.propertyType !== "iroda-irodahaz" &&
            _vm.propertyType !== "raktar"
              ? _c("fieldset", [_vm._v("Fűtés:")])
              : _vm._e(),
            _vm._v(" "),
            _vm.propertyType !== "telek" &&
            _vm.propertyType !== "garazs" &&
            _vm.propertyType !== "kereskedelmi-ipari-ingatlan" &&
            _vm.propertyType !== "iroda-irodahaz" &&
            _vm.propertyType !== "raktar"
              ? _c("multiselect", {
                  attrs: {
                    title: _vm.t("property.heating", "Fűtés"),
                    dataKey: "heatingTypes",
                    checkboxName: "ht_id",
                    selectData: _vm.heatingTypes,
                    onChange: _vm.onMultiSelectChange,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.propertyType === "lakas"
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("fieldset", [_vm._v("Emeletek:")]),
                _vm._v(" "),
                _vm.propertyType === "lakas"
                  ? _c("multiselect", {
                      attrs: {
                        title: _vm.t("property.floor", "Emelet"),
                        dataKey: "floorTypes",
                        selectData: _vm.floorTypes,
                        onChange: _vm.onMultiSelectChange,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("fieldset", [_vm._v("Ár:")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-6" },
        [
          _c("multiselect", {
            attrs: {
              title: "Árváltozás",
              dataKey: "priceChanged",
              selectData: _vm.priceChanged,
              singleSelect: true,
              noDefaultOption: true,
              onChange: _vm.onSingleSelectChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("range", {
        attrs: {
          data: this,
          from: "priceMin",
          to: "priceMax",
          label: `${_vm.t("property.price", "Ár")} (${
            _vm.isForSale
              ? _vm.t("price.millionPrefix", "M")
              : _vm.t("price.thousandPrefix", "E")
          } ${_vm.t("property.ft", "Ft")})`,
          placeholderValues: { min: 10, max: 100 },
        },
        on: { onRangeValueChange: _vm.onRangeValueChange },
      }),
      _vm._v(" "),
      _c("range", {
        attrs: {
          data: this,
          from: "priceMinEur",
          to: "priceMaxEur",
          label: `Ár (E EUR)`,
          placeholderValues: { min: 1, max: 100 },
        },
        on: { onRangeValueChange: _vm.onRangeValueChange },
      }),
      _vm._v(" "),
      _vm.propertyType !== "telek"
        ? _c("fieldset", [_vm._v("Terület:")])
        : _vm._e(),
      _vm._v(" "),
      _vm.propertyType !== "telek"
        ? _c("range", {
            attrs: {
              data: this,
              from: "sizeMin",
              to: "sizeMax",
              label: `${_vm.t("property.size", "Alapterület")} (${_vm.t(
                "property.m2",
                "m<sup>2</sup>"
              )})`,
              placeholderValues: { min: 100, max: 120 },
            },
            on: { onRangeValueChange: _vm.onRangeValueChange },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.propertyType !== "telek" &&
      _vm.propertyType !== "garazs" &&
      _vm.propertyType !== "kereskedelmi-ipari-ingatlan" &&
      _vm.propertyType !== "iroda-irodahaz" &&
      _vm.propertyType !== "raktar"
        ? _c("range", {
            attrs: {
              data: this,
              from: "plotSizeMin",
              to: "plotSizeMax",
              label: `${_vm.t("property.plotSize", "Telekterület")} (${_vm.t(
                "property.m2",
                "m<sup>2</sup>"
              )})`,
              placeholderValues: { min: 600, max: 899 },
            },
            on: { onRangeValueChange: _vm.onRangeValueChange },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.propertyType !== "telek" &&
      _vm.propertyType !== "garazs" &&
      _vm.propertyType !== "kereskedelmi-ipari-ingatlan" &&
      _vm.propertyType !== "iroda-irodahaz" &&
      _vm.propertyType !== "raktar"
        ? _c("range", {
            attrs: {
              data: this,
              from: "roomsNumMin",
              to: "roomsNumMax",
              label: `${_vm.t("property.rooms", "Szobák")} (${_vm.t(
                "property.db",
                "db"
              )})`,
              placeholderValues: { min: 1, max: 4 },
            },
            on: { onRangeValueChange: _vm.onRangeValueChange },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.propertyType === "haz-hazresz" &&
      _vm.propertyType === "udulo-hetvegi-haz" &&
      _vm.propertyType === "fold-kert-tanya"
        ? _c("range", {
            attrs: {
              data: this,
              from: "adLevelFrom",
              to: "adLevelTo",
              label: `Belső szintek`,
              placeholderValues: { min: 1, max: 10 },
            },
            on: { onRangeValueChange: _vm.onRangeValueChange },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm.propertyType === "lakas"
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("fieldset", [_vm._v("Tetőtéri:")]),
                _vm._v(" "),
                _vm.propertyType === "lakas"
                  ? _c("multiselect", {
                      attrs: {
                        title: "Tetőtéri",
                        dataKey: "attic",
                        selectData: _vm.attic,
                        singleSelect: true,
                        defaultLabel: "Tetőtéri",
                        onChange: _vm.onSingleSelectChange,
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.propertyType === "lakas"
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("fieldset", [_vm._v("Lift:")]),
                _vm._v(" "),
                _vm.propertyType === "lakas"
                  ? _c("multiselect", {
                      attrs: {
                        title: "Lift",
                        dataKey: "lift",
                        selectData: _vm.lift,
                        singleSelect: true,
                        defaultLabel: "Lift",
                        onChange: _vm.onSingleSelectChange,
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.propertyType !== "telek" && _vm.propertyType !== "garazs"
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("fieldset", [_vm._v("Építőanyag:")]),
                _vm._v(" "),
                _vm.propertyType !== "telek" && _vm.propertyType !== "garazs"
                  ? _c("multiselect", {
                      attrs: {
                        title: "Építőanyag",
                        dataKey: "materialTypes",
                        selectData: _vm.materialTypes,
                        singleSelect: true,
                        defaultLabel: "Építőanyag",
                        onChange: _vm.onSingleSelectChange,
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.propertyType !== "telek" && _vm.propertyType !== "garazs"
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("fieldset", [_vm._v("Szigetelt:")]),
                _vm._v(" "),
                _vm.propertyType !== "telek" && _vm.propertyType !== "garazs"
                  ? _c("multiselect", {
                      attrs: {
                        title: "Szigetelt",
                        dataKey: "dryvit",
                        selectData: _vm.dryvit,
                        singleSelect: true,
                        defaultLabel: "Dryvitolt",
                        onChange: _vm.onSingleSelectChange,
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.propertyType !== "telek" && _vm.propertyType !== "garazs"
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("fieldset", [_vm._v("Komfort:")]),
                _vm._v(" "),
                _vm.propertyType !== "telek" && _vm.propertyType !== "garazs"
                  ? _c("multiselect", {
                      attrs: {
                        title: "Komfort",
                        dataKey: "comfort",
                        selectData: _vm.comfort,
                        singleSelect: true,
                        defaultLabel: "Komfort",
                        onChange: _vm.onSingleSelectChange,
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.propertyType !== "telek" &&
        _vm.propertyType !== "garazs" &&
        _vm.propertyType !== "kereskedelmi-ipari-ingatlan" &&
        _vm.propertyType !== "iroda-irodahaz" &&
        _vm.propertyType !== "raktar"
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("fieldset", [_vm._v("Erkély típusa:")]),
                _vm._v(" "),
                _vm.propertyType !== "telek" &&
                _vm.propertyType !== "garazs" &&
                _vm.propertyType !== "kereskedelmi-ipari-ingatlan" &&
                _vm.propertyType !== "iroda-irodahaz" &&
                _vm.propertyType !== "raktar"
                  ? _c("multiselect", {
                      attrs: {
                        title: "Erkély típusa",
                        dataKey: "balconyTypes",
                        selectData: _vm.balconyTypes,
                        singleSelect: true,
                        defaultLabel: "Erkély típusa",
                        onChange: _vm.onSingleSelectChange,
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm.propertyType !== "garazs"
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("fieldset", [_vm._v("Kilátás:")]),
                _vm._v(" "),
                _vm.propertyType !== "garazs"
                  ? _c("multiselect", {
                      attrs: {
                        title: "Kilátás",
                        dataKey: "viewTypes",
                        selectData: _vm.viewTypes,
                        singleSelect: true,
                        defaultLabel: "Kilátás",
                        onChange: _vm.onSingleSelectChange,
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.propertyType !== "garazs"
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("fieldset", [_vm._v("Tájolás:")]),
                _vm._v(" "),
                _vm.propertyType !== "garazs"
                  ? _c("multiselect", {
                      attrs: {
                        title: "Tájolás",
                        dataKey: "orientations",
                        selectData: _vm.orientations,
                        singleSelect: true,
                        defaultLabel: "Tájolás",
                        onChange: _vm.onSingleSelectChange,
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.propertyType !== "telek" && _vm.propertyType !== "garazs"
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("fieldset", [_vm._v("Klímatizált:")]),
                _vm._v(" "),
                _vm.propertyType !== "telek" && _vm.propertyType !== "garazs"
                  ? _c("multiselect", {
                      attrs: {
                        title: "Klímatizált",
                        dataKey: "airConditioner",
                        selectData: _vm.airConditioner,
                        singleSelect: true,
                        defaultLabel: "Klímatizált",
                        onChange: _vm.onSingleSelectChange,
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.propertyType !== "telek" && _vm.propertyType !== "garazs"
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("fieldset", [_vm._v("Kábelszolgáltató:")]),
                _vm._v(" "),
                _vm.propertyType !== "telek" && _vm.propertyType !== "garazs"
                  ? _c("freetext", {
                      attrs: {
                        data: this,
                        text: "networkService",
                        fieldName: "networkService",
                        placeholder: "pl. Telekom",
                      },
                      on: { onValueChange: _vm.onValueChange },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm.propertyType !== "telek" && _vm.propertyType !== "garazs"
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("fieldset", [_vm._v("Parkolási lehetőség:")]),
                _vm._v(" "),
                _vm.propertyType !== "telek" && _vm.propertyType !== "garazs"
                  ? _c("multiselect", {
                      attrs: {
                        title: "Parkolási lehetőség",
                        dataKey: "parking",
                        selectData: _vm.parking,
                        singleSelect: true,
                        defaultLabel: "Parkolási lehetőség",
                        onChange: _vm.onSingleSelectChange,
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.propertyType !== "telek"
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("fieldset", [_vm._v("Elektromos autó töltés:")]),
                _vm._v(" "),
                _vm.propertyType !== "telek"
                  ? _c("multiselect", {
                      attrs: {
                        title: "Elektromos autó töltés",
                        dataKey: "carCharger",
                        selectData: _vm.carCharger,
                        singleSelect: true,
                        defaultLabel: "Elektromos autó töltés",
                        onChange: _vm.onSingleSelectChange,
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.propertyType !== "telek" && _vm.propertyType !== "garazs"
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("fieldset", [_vm._v("Akadálymentesített?")]),
                _vm._v(" "),
                _vm.propertyType !== "telek" && _vm.propertyType !== "garazs"
                  ? _c("multiselect", {
                      attrs: {
                        title: "Akadálymentesített",
                        dataKey: "barrierFree",
                        selectData: _vm.barrierFree,
                        singleSelect: true,
                        defaultLabel: "Akadálymentesített",
                        onChange: _vm.onSingleSelectChange,
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm.propertyType === "telek"
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("fieldset", [_vm._v("Közművek - víz")]),
                _vm._v(" "),
                _vm.propertyType === "telek"
                  ? _c("multiselect", {
                      attrs: {
                        title: "Víz",
                        dataKey: "adUtilityWater",
                        selectData: _vm.adUtilityWater,
                        singleSelect: true,
                        defaultLabel: "Víz",
                        onChange: _vm.onSingleSelectChange,
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.propertyType === "telek"
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("fieldset", [_vm._v("Közművek - csatorna")]),
                _vm._v(" "),
                _vm.propertyType === "telek"
                  ? _c("multiselect", {
                      attrs: {
                        title: "Csatorna",
                        dataKey: "adUtilityChannel",
                        selectData: _vm.adUtilityChannel,
                        singleSelect: true,
                        defaultLabel: "Csatorna",
                        onChange: _vm.onSingleSelectChange,
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm.propertyType === "telek"
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("fieldset", [_vm._v("Közművek - gáz")]),
                _vm._v(" "),
                _vm.propertyType === "telek"
                  ? _c("multiselect", {
                      attrs: {
                        title: "Gáz",
                        dataKey: "adUtilityGas",
                        selectData: _vm.adUtilityGas,
                        singleSelect: true,
                        defaultLabel: "Gáz",
                        onChange: _vm.onSingleSelectChange,
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.propertyType === "telek"
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("fieldset", [_vm._v("Közművek - villany")]),
                _vm._v(" "),
                _vm.propertyType === "telek"
                  ? _c("multiselect", {
                      attrs: {
                        title: "Villany",
                        dataKey: "adUtilityElectricity",
                        selectData: _vm.adUtilityElectricity,
                        singleSelect: true,
                        defaultLabel: "Villany",
                        onChange: _vm.onSingleSelectChange,
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.propertyType !== "telek"
        ? _c("fieldset", [_vm._v("Biztosítás, rezsiköltségek:")])
        : _vm._e(),
      _vm._v(" "),
      _vm.propertyType !== "telek"
        ? _c("range", {
            attrs: {
              data: this,
              from: "insuranceFrom",
              to: "insuranceTo",
              label: `Biztosítás díja`,
              placeholderValues: { min: 10000, max: 100000 },
            },
            on: { onRangeValueChange: _vm.onRangeValueChange },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.propertyType !== "telek"
        ? _c("range", {
            attrs: {
              data: this,
              from: "costFrom",
              to: "costTo",
              label: `Havi rezsiköltség`,
              placeholderValues: { min: 10000, max: 100000 },
            },
            on: { onRangeValueChange: _vm.onRangeValueChange },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "search-filter__block btn btn--search",
          attrs: { type: "submit" },
          on: {
            click: function ($event) {
              return _vm.submit($event)
            },
          },
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.t("property.searchNow", "Keresés")))]),
          _vm._v(" "),
          typeof _vm.hitsCount !== "undefined"
            ? _c(
                "span",
                { staticClass: "hits-counter" },
                [
                  _c("br"),
                  _vm._v("\n      ("),
                  _c("animated-number", {
                    attrs: {
                      value: _vm.hitsCount,
                      round: 1,
                      formatValue: _vm.formatNumber,
                      duration: 1000,
                    },
                  }),
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        ` ${_vm.t("property.resultsFound", "várható találat")}`
                      ) +
                      ")\n    "
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }